module.exports = __webpack_public_path__ + "static/media/gameplay_bg_03.4936944a.jpg";